import React, { createContext } from "react";
import PropTypes from "prop-types";
export var RoutesContext = /*#__PURE__*/ createContext();
RoutesContextProvider.propTypes = {
    routes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired
};
export default function RoutesContextProvider(param) {
    var routes = param.routes, children = param.children;
    return /*#__PURE__*/ React.createElement(RoutesContext.Provider, {
        value: {
            routes: routes
        }
    }, children);
}
